import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Session} from '../../domain/session';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.css'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  code: string;
  description: string;
  icon: string;
  css_class: string;

  constructor(private route: ActivatedRoute, private router: Router, public session: Session) {
  }

  ngOnInit() {
    this.init();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.init();
      });
  }

  private init() {
    this.code = this.route.snapshot.paramMap.get('code');
    this.description = this.route.snapshot.paramMap.get('description');
    this.icon = this.route.snapshot.paramMap.get('icon');
    this.css_class = this.route.snapshot.paramMap.get('css_class');
  }
}
